import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { VENDOR_SUBMIT_API_URL } from '../../../../constants/ApiUrlConstants';
import { DASHBOARD_ROUTE } from '../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import history from '../../../../features/history';
import { VendorRoleEditorSubmitFailure, VendorRoleEditorSubmitSuccess } from '../actions';

const VendorSubmitFileAPI = (action) => postApiRequest(VENDOR_SUBMIT_API_URL, action);

function forwardTo(location) {
  history.push(location);
}

function* handleVendorSubmitFile(action) {
  try {
    const response = yield call(VendorSubmitFileAPI, action.payload);
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
    }
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    if (response?.data?.success) {
      yield call(forwardTo, DASHBOARD_ROUTE);
    }
    yield put(VendorRoleEditorSubmitSuccess(response));
  } catch (error) {
    yield put(VendorRoleEditorSubmitFailure(error));
  }
}

export function* watchVendorSubmitFile() {
  yield takeLatest(types.VENDOR_ROLE_EDITOR_SUBMIT_REQUEST, handleVendorSubmitFile);
}
